import { helpers } from "vuelidate/lib/validators";

const phoneCharacters = (value) =>
  !helpers.req(value) || value.match(/([^-+() 0-9])/) == null;

const beforeToday = (dateAsString) =>
  !helpers.req(dateAsString) || new Date(dateAsString) < new Date();

const maxFileSize = (maxSize) => (file) =>
  !helpers.req(file) || file.size < maxSize;

export { phoneCharacters, beforeToday, maxFileSize };
